// extracted by mini-css-extract-plugin
module.exports = {"cardStyle":"index_cardStyle__Oceoc"};